import { Box, Image } from '@modusign/design-system';

interface HeaderImageProps {
  src: string;
}

export default function HeaderImage({ src }: HeaderImageProps) {
  return (
    <Box height={120} width={120}>
      <Image src={src} />
    </Box>
  );
}
